// File: frontend/src/pages/dashboards/GenericDashboard.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const GenericDashboard = ({ title = 'Dashboard', description = 'Welcome to your dashboard portal.' }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Handle logout asynchronously
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error in GenericDashboard:', error);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-primary text-white flex items-center justify-center font-bold text-lg">
              SMS
            </div>
            <div>
              <h1 className="font-bold text-slate-800 text-lg">{title}</h1>
              <p className="text-xs text-slate-500">School Management System</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-sm font-semibold text-slate-800">
              {user?.name || user?.email || 'User'}
            </span>
            <button
              onClick={handleLogout}
              className="bg-slate-100 hover:bg-red-50 hover:text-red-600 text-slate-700 font-medium px-4 py-2 rounded-xl text-sm transition"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm text-center">
          <div className="w-16 h-16 bg-blue-50 text-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5m0 0h4m-4 0V11m0 0h4m-4 0h-4" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-slate-800 mb-2">{title}</h2>
          <p className="text-slate-500 text-sm max-w-md mx-auto">
            {description}
          </p>
        </div>
      </main>
    </div>
  );
};

export default GenericDashboard;
